var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4167 7.25L21.9332 17.7495C21.3738 18.0744 20.7385 18.2455 20.0916 18.2455C19.4447 18.2455 18.8094 18.0744 18.25 17.7495L1.75 7.25M5.41667 1.75H34.75C36.775 1.75 38.4167 3.39162 38.4167 5.41667V27.4167C38.4167 29.4417 36.775 31.0833 34.75 31.0833H5.41667C3.39162 31.0833 1.75 29.4417 1.75 27.4167V5.41667C1.75 3.39162 3.39162 1.75 5.41667 1.75Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a6cc66b5125460d2953dab0fa98e939.svg";
export { ForwardRef as ReactComponent };